/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["frame-drawer .button-with-image{position:relative}frame-drawer .button-with-image img{border-radius:4px;width:65px;height:65px}frame-drawer .button-with-image .bottom-label{margin-top:3px;font-size:11px}@media only screen and (max-width:599.99px){frame-drawer.controls-drawer .main-content{justify-content:flex-start}frame-drawer .frame-controls{padding:0 15px}}"];
export { styles as styles };
